export default {
    selectedTab: 0,
    fabricInfoOpened: false,
    zoomMode: false,
    imagesLoading: false,
    builderPage : 1,
    sizesSnackOpened : false,
    priceChanged : false,
    activeDetailsPreset: null,
    activeFabricFilters: {},
  }